import { render, staticRenderFns } from "./CrearMensajeModal.vue?vue&type=template&id=464d03bc&"
import script from "./CrearMensajeModal.vue?vue&type=script&lang=ts&"
export * from "./CrearMensajeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('464d03bc', component.options)
    } else {
      api.reload('464d03bc', component.options)
    }
    module.hot.accept("./CrearMensajeModal.vue?vue&type=template&id=464d03bc&", function () {
      api.rerender('464d03bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/CrearMensajeModal.vue"
export default component.exports